import { Progress } from '@nextui-org/react';

interface TopLoadingBarProps {
  /** Show or hide the bar. When false the component renders nothing. */
  isLoading: boolean;
  /** Accessible label for the progress indicator. */
  ariaLabel?: string;
  /**
   * Extra classes to append to the base container — useful for overriding
   * positioning (e.g. `top-[NN]` when nesting inside a scrolling container).
   */
  className?: string;
}

/**
 * Thin top-of-container loading bar. Positioned absolutely at the top of
 * the nearest positioned ancestor, so drop it as a direct child of a
 * `relative`-positioned wrapper.
 *
 * Uses NextUI's indeterminate `Progress` under the hood with a cherry-toned
 * gradient indicator. Shows while `isLoading` is true, nothing otherwise.
 */
const TopLoadingBar = ({
  isLoading,
  ariaLabel = 'Cargando...',
  className = '',
}: TopLoadingBarProps) => {
  if (!isLoading) return null;

  return (
    <Progress
      isIndeterminate
      size='sm'
      aria-label={ariaLabel}
      classNames={{
        base: `absolute top-0 left-0 right-0 z-40 h-[3px] rounded-none ${className}`,
        track: 'bg-cherry-100/40 dark:bg-cherry-950/40 rounded-none',
        indicator: 'bg-gradient-to-r from-cherry-500 to-cherry-400',
      }}
    />
  );
};

export default TopLoadingBar;
